// extracted by mini-css-extract-plugin
export default {"title":"bank-yang-digunakan_title__KhxBU"};